<span [class]="badgeClass()" [style.color]="colors()?.text" [style.backgroundColor]="colors()?.background">
  @if (hasIcon() && isIconLeft()) {
    <span class="so-badge__icon material-icons">{{ icon() }}</span>
  }
  <span class="so-badge__text">{{ text() }}</span>
  @if (hasIcon() && !isIconLeft()) {
    <span class="so-badge__icon material-icons">{{ icon() }}</span>
  }
</span>
